export const CONSULT_DETAILS_REQUESTED = 'CONSULT_DETAILS_REQUESTED';
export const CONSULT_DETAILS_SUCCEED = 'CONSULT_DETAILS_SUCCEED';
export const CONSULT_DETAILS_FAILED = 'CONSULT_DETAILS_FAILED';

export const CONSULT_FINISH_REQUESTED = 'CONSULT_FINISH_REQUESTED';
export const CONSULT_FINISH_SUCCEED = 'CONSULT_FINISH_SUCCEED';
export const CONSULT_FINISH_FAILED = 'CONSULT_FINISH_FAILED';

export const CONSULT_ACCEPT_REQUESTED = 'CONSULT_ACCEPT_REQUESTED';
export const CONSULT_ACCEPT_SUCCEED = 'CONSULT_ACCEPT_SUCCEED';
export const CONSULT_ACCEPT_FAILED = 'CONSULT_ACCEPT_FAILED';

export const CONSULT_UPDATE_REQUESTED = 'CONSULT_UPDATE_REQUESTED';
export const CONSULT_UPDATE_SUCCEED = 'CONSULT_UPDATE_SUCCEED';
export const CONSULT_UPDATE_FAILED = 'CONSULT_UPDATE_FAILED';

export const CONSULT_GET_ONGOING_REQUESTED = 'CONSULT_GET_ONGOING_REQUESTED';
export const CONSULT_GET_ONGOING_SUCCEED = 'CONSULT_GET_ONGOING_SUCCEED';
export const CONSULT_GET_ONGOING_FAILED = 'CONSULT_GET_ONGOING_FAILED';

export const CONSULT_REGISTER_TOKEN_REQUESTED = 'CONSULT_REGISTER_TOKEN_REQUESTED';
export const CONSULT_REGISTER_TOKEN_SUCCEED = 'CONSULT_REGISTER_TOKEN_SUCCEED';
export const CONSULT_REGISTER_TOKEN_FAILED = 'CONSULT_REGISTER_TOKEN_FAILED';

export const CONSULT_UNREGISTER_TOKEN_REQUESTED = 'CONSULT_UNREGISTER_TOKEN_REQUESTED';
export const CONSULT_UNREGISTER_TOKEN_SUCCEED = 'CONSULT_UNREGISTER_TOKEN_SUCCEED';
export const CONSULT_UNREGISTER_TOKEN_FAILED = 'CONSULT_UNREGISTER_TOKEN_FAILED';

export const CONSULTS_PENDING_GET_REQUESTED = 'CONSULTS_PENDING_GET_REQUESTED';
export const CONSULTS_PENDING_GET_SUCCEED = 'CONSULTS_PENDING_GET_SUCCEED';
export const CONSULTS_PENDING_GET_FAILED = 'CONSULTS_PENDING_GET_FAILED';

export const CONSULTS_PENDING_STATS_REQUESTED = 'CONSULTS_PENDING_STATS_REQUESTED';
export const CONSULTS_PENDING_STATS_SUCCEED = 'CONSULTS_PENDING_STATS_SUCCEED';
export const CONSULTS_PENDING_STATS_FAILED = 'CONSULTS_PENDING_STATS_FAILED';

export const CONSULT_PENDING_ACCEPT_REQUESTED = 'CONSULT_PENDING_ACCEPT_REQUESTED';
export const CONSULT_PENDING_ACCEPT_SUCCEED = 'CONSULT_PENDING_ACCEPT_SUCCEED';
export const CONSULT_PENDING_ACCEPT_FAILED = 'CONSULT_PENDING_ACCEPT_FAILED';

export const CONSULT_PENDING_RESET_STATE = 'CONSULT_PENDING_RESET_STATE';

export const CONSULT_PENDING_UPDATE_STATE = 'CONSULT_PENDING_UPDATE_STATE';
export const CONSULT_PENDING_STATS_INCREASE_TOTAL = 'CONSULT_PENDING_STATS_INCREASE_TOTAL';
export const CONSULT_PENDING_STATS_DECREASE_TOTAL = 'CONSULT_PENDING_STATS_DECREASE_TOTAL';

export const CONSULT_PENDING_REMOVE = 'CONSULT_PENDING_REMOVE';
export const CONSULT_PENDING_ADDED = 'CONSULT_PENDING_ADDED';

export const CONSULT_DETAILS_POOL_REQUESTED = 'CONSULT_DETAILS_POOL_REQUESTED';
export const CONSULT_DETAILS_POOL_SUCCEED = 'CONSULT_DETAILS_POOL_SUCCEED';
export const CONSULT_DETAILS_POOL_FAILED = 'CONSULT_DETAILS_POOL_FAILED';

export const CONSULT_STATUS_RESET_STATE = 'CONSULT_STATUS_RESET_STATE';

export const CONSULT_MEMBER_GET_REQUESTED = 'CONSULT_MEMBER_GET_REQUESTED';
export const CONSULT_MEMBER_GET_SUCCEED = 'CONSULT_MEMBER_GET_SUCCEED';
export const CONSULT_MEMBER_GET_FAILED = 'CONSULT_MEMBER_GET_FAILED';

export const CONSULT_GET_DETAILS_REQUESTED = 'CONSULT_GET_DETAILS_REQUESTED';
export const CONSULT_GET_DETAILS_SUCCEED = 'CONSULT_GET_DETAILS_SUCCEED';
export const CONSULT_GET_DETAILS_FAILED = 'CONSULT_GET_DETAILS_FAILED';

export const CONSULT_CREATE_REQUESTED = 'CONSULT_CREATE_REQUESTED';
export const CONSULT_CREATE_SUCCEED = 'CONSULT_CREATE_SUCCEED';
export const CONSULT_CREATE_FAILED = 'CONSULT_CREATE_FAILED';

export const CONSULT_FOLLOWUP_REQUESTED = 'CONSULT_FOLLOWUP_REQUESTED';
export const CONSULT_FOLLOWUP_SUCCEED = 'CONSULT_FOLLOWUP_SUCCEED';
export const CONSULT_FOLLOWUP_FAILED = 'CONSULT_FOLLOWUP_FAILED';

export const CONSULT_PENDING_ACTIVE = 'CONSULT_PENDING_ACTIVE';

export const CONSULT_SET_MAIN_PROVIDER_REQUESTED = 'CONSULT_SET_MAIN_PROVIDER_REQUESTED';
export const CONSULT_SET_MAIN_PROVIDER_SUCCEED = 'CONSULT_SET_MAIN_PROVIDER_SUCCEED';
export const CONSULT_SET_MAIN_PROVIDER_FAILED = 'CONSULT_SET_MAIN_PROVIDER_FAILED';

export const CONSULTATION_CLINIC_GET_REQUESTED = 'CONSULTATION_CLINIC_GET_REQUESTED';
export const CONSULTATION_CLINIC_GET_SUCCEEDED = 'CONSULTATION_CLINIC_GET_SUCCEEDED';
export const CONSULTATION_CLINIC_GET_FAILED = 'CONSULTATION_CLINIC_GET_FAILED';

export const CONSULT_GEN_CLINICAL_NOTE_REQUESTED = 'CONSULT_GEN_CLINICAL_NOTE_REQUESTED';
export const CONSULT_GEN_CLINICAL_NOTE_SUCCEED = 'CONSULT_GEN_CLINICAL_NOTE_SUCCEED';
export const CONSULT_GEN_CLINICAL_NOTE_FAILED = 'CONSULT_GEN_CLINICAL_NOTE_FAILED';

export const CONSULT_SWITCH_TO_OTHER_CLINIC_REQUESTED = 'CONSULT_SWITCH_TO_OTHER_CLINIC_REQUESTED';
export const CONSULT_SWITCH_TO_OTHER_CLINIC_SUCCEED = 'CONSULT_SWITCH_TO_OTHER_CLINIC_SUCCEED';
export const CONSULT_SWITCH_TO_OTHER_CLINIC_FAILED = 'CONSULT_SWITCH_TO_OTHER_CLINIC_FAILED';

export const CONSULT_SWITCH_TO_OTHER_CLINIC_RESET_STATE =
  'CONSULT_SWITCH_TO_OTHER_CLINIC_RESET_STATE';

export const CONSULT_RESET_STATE = 'CONSULT_RESET_STATE';

export const CONSULT_PATIENT_GET_REQUESTED = 'CONSULT_PATIENT_GET_REQUESTED';
export const CONSULT_PATIENT_GET_SUCCEED = 'CONSULT_PATIENT_GET_SUCCEED';
export const CONSULT_PATIENT_GET_FAILED = 'CONSULT_PATIENT_GET_FAILED';
